import { useState } from "react";
import { BookOpen } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";
import { PdfDialog } from "./PdfDialog";

// Top-right button: opens the PDF manual on screen, with a download option.
export const ManualButton = () => {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const open = async () => {
    setBusy(true);
    try {
      const { data } = await api.get("/manual.pdf", { responseType: "blob" });
      setUrl(URL.createObjectURL(new Blob([data], { type: "application/pdf" })));
    } catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  const close = () => { URL.revokeObjectURL(url); setUrl(null); };
  return (
    <>
      <button onClick={open} disabled={busy} title="How to Manual (PDF)" data-testid="manual-link"
        className="h-9 px-4 rounded-full bg-yellow-300 shadow-sm text-yellow-950 text-sm font-bold hover:bg-yellow-400 flex items-center gap-1.5 whitespace-nowrap transition-colors disabled:opacity-60">
        <BookOpen className="h-4 w-4" /><span>{busy ? "Opening…" : "How to Manual"}</span>
      </button>
      <PdfDialog url={url} title="POS Finder Manual" filename="POS-Finder-Manual.pdf" onClose={close} testid="manual-viewer" />
    </>
  );
};
